module.exports = __webpack_public_path__ + "img/attune.e03ae769.png";